import request from "@/http"
import http from "@/http/http"
import type {
  IndustryCategory,
  // IndustryDataRange,
  IndustryModuleType,
  // RoleAuthStrategy,
  SceneCustomerType,
} from "@/api"
import { MAP_SEARCH_URL } from "@/constants/config"
import type { AxiosRequestConfig } from "axios"

export interface SiteSelectionsAuthVO {
  [x: string]: any
  // 选址方式
  model: string
  // 剩余次数
  rest: number
  // 是否不限城市，true表示不限城市, 默认false限制城市
  notRestrictCity: boolean
}

export interface AreaItemVO {
  areaCode: number
  areaName: string
  level: number
  children: AreaItemVO[]
}

export interface ModuleItemVO {
  moduleName: string
  moduleType: string
  // true: 有权限；false: 没权限
  unlocked: boolean
  children: ModuleItemVO[]
}

export interface IndustryConf {
  // 显示名称
  showName: string
  // 菜单
  modules: ModuleItemVO[]
  // 生态类型
  moduleTypes: IndustryModuleType[]
  // 指标权限
  // quota: string[]
  // 场景拓客类型
  sceneCustomerTypes: SceneCustomerType[]
  // 智能选址
  siteSelections: SiteSelectionsAuthVO[]
  // 城市id
  // cityId: string
  // 城市名
  // cityName: string
  // 品牌id
  brandId: string
  // 品牌名称
  brandName: string
  // 模块是否可见
  visible: boolean
  // 数据查看范围
  // dataRange: IndustryDataRange
  // 角色权限
  // roleAuths: RoleAuthStrategy[]
  // 品牌类型
  industryCategory: IndustryCategory
  // 是否只有一个网点的权限（单网点）
  singleStoreAuth: boolean
  // 是否限制网点个数
  singleAuth: boolean
  // 区域权限
  area: AreaItemVO[]
  // 是否有系统配置权限
  systemConfigAuth: boolean
  // 是否有chargpt权限
  gptAuth: boolean
  // 网点辐射半径（周边生态）
  nearbyEcologyRadius: number
}

interface CommonConfigArgs {
  cityId: string
  sandTableType: string
  brandId?: string
}

/**
 *
 * 获取当前配置
 * @export
 * @param
 * @returns
 */
export async function getCitys(args: CommonConfigArgs): Promise<IndustryConf> {
  try {
    const { cityId, ...others } = args
    const result = await http.get("/business/common/config", {
      params: {
        ...others,
        areaCode: cityId,
      },
    })
    return result?.data
  } catch (error) {
    throw error
  }
}

export async function getAreaChildren(areaCode: any): Promise<any> {
  try {
    const result = await http.get("/siteSelection/sites/areaChildren", {
      params: {
        areaCode,
      },
    })
    return result?.data
  } catch (error) {
    throw error
  }
}

// 逆地理编码（坐标 -> 地址）
export function geocodeRegeo(
  coordinate: number[],
  callback: (status: string, data?: { address: string; adcode: string }) => void,
) {
  if (coordinate) {
    request
      .get("/business/common/regeo", {
        params: { location: coordinate.join(",") },
        cancelLoading: true,
      } as AxiosRequestConfig)
      .then((result: any) => {
        const {
          status,
          regeocode: { addressComponent, formatted_address },
        } = result.data.data
        if (status === "1") {
          callback(status, {
            ...addressComponent,
            address: formatted_address,
          })
        } else {
          callback("0")
        }
      })
  }
}

interface QueryAddressArgs {
  city: string
  keywords: string
}

interface TipsItemVO {
  adcode: string
  address: string
  city: string[]
  district: string
  id: string
  location: string
  name: string
  typecode: string
}

interface QueryAddressResult {
  count: string
  info: string
  infocode: string
  status: string
  tips: TipsItemVO[]
}

// 根据地址查询地址列表
export async function queryAddressTips(params: QueryAddressArgs): Promise<QueryAddressResult> {
  try {
    const result = await request.post<QueryAddressResult>(MAP_SEARCH_URL, params)
    return result?.data
  } catch (error) {
    throw error
  }
}
